export const LOCAL_STORAGE = {
  JJ_INTERNAL: '@JJFoodservice.accessToken',
  CODE_VERIFIER: 'codeVerifier',
  REDIRECT: 'redirectUrl',
};

export const CLIENT_ID = '2bfe81fe-2afd-4c81-a6fc-31c808cea85c';
export const TENANT_ID = 'c46924d0-d32d-4006-829b-d1d39bd0f672';

export const branches = ["SD-MW", "AS-MW", "BR-MW", "BS-MW", "DN-MW", "LD-MW", "MN-MW", "DG-MW", "LS-MW", "NC-MW", "WB-MW"];
export const  DEFAULT_BRANCH = "EN-MW"

export const devPrefix = '-dev'
export const devSuffix = 'not'
export const uatPrefix = '-uat'
export const ecom = 'ecom'